module.exports = __webpack_public_path__ + "static/media/NBIoT通信模块.baac2c82.png";